if (!customElements.get('m-product-size-guide')) {
  customElements.define(
    'm-product-size-guide',
    class MProductSizeGuide extends HTMLElement {
      connectedCallback() {
        this.openButton = this.querySelector('[data-open-product-size-guide]')
        this.content = this.querySelector('[data-product-size-guide-content]')

        if (!this.openButton || !this.content || !this.content.innerHTML.trim()) return

        this.modal = new MinimogTheme.Modal()
        this.openButton.addEventListener('click', this.openModal)
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener('click', this.openModal)
      }

      openModal = (event) => {
        event.preventDefault()
        const modalContent = document.createElement('div')
        modalContent.className = `m-product-size-guide__modal m-gradient ${this.content.dataset.colorScheme || ''}`
        modalContent.innerHTML = this.content.innerHTML
        this.modal.appendChild(modalContent)
        this.modal.setWidth('700px')
        this.modal.setSizes('m-product-size-guide__dialog')
        this.modal.open()
      }
    }
  )
}
